import React from "react";
import type { Message } from "./types";

type ChatMessageListProps = {
  messages: Message[];
};

const GreetingMessage: Message = {
  role: "assistant",
  text: "Hi, how can I help you today?",
  timeStamp: null,
};

export const ChatMessageList: React.FC<ChatMessageListProps> = ({
  messages,
}) => {
  const renderChatMessage = (
    message: Message,
    index: number
  ): React.JSX.Element => {
    return (
      <li
        key={index}
        className={`tw-flex tw-flex-row tw-w-full tw-mb-4 ${
          message.role == "assistant" ? "tw-justify-start" : "tw-justify-end"
        }`}
      >
        <div
          className={`tw-w-fit tw-max-w-xl tw-p-4 tw-rounded ${
            message.role === "user" ? "tw-bg-gray-200" : ""
          }`}
        >
          {message.role === "assistant" && (
            <div className="tw-font-semibold">Assistant</div>
          )}

          <p>{message.text}</p>
          {message.timeStamp && (
            <time
              className={`tw-text-xs tw-mt-2 tw-text-gray-500 ${
                message.role === "user" ? "tw-text-right" : ""
              }`}
            >
              {new Date(message.timeStamp).toLocaleString()}
            </time>
          )}
        </div>
      </li>
    );
  };

  return (
    <ul>
      {messages.length > 0
        ? messages.map((message, index) => renderChatMessage(message, index))
        : renderChatMessage(GreetingMessage, 0)}
    </ul>
  );
};
